import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { singularize, toCamelCase, toPascalCase } from '@cli-utils/text.js'
import { renderBuildRestoreManyToManyStatementsValueTemplate } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/build-restore-many-to-many-statements.js'

export function buildRestoreManyToManyStatements(ctx: EntityCtx): string {
  return ctx.m2mFields
    .map((field) => {
      const rel = field.relationship || ''
      const RelPascal = toPascalCase(rel)
      const relSingular = singularize(rel)
      const junctionVar = toCamelCase(`${ctx.singular}${RelPascal}`)
      const entityIdCol = `${ctx.singular}Id`
      const relIdCol = `${relSingular}Id`

      return renderBuildRestoreManyToManyStatementsValueTemplate({
        fieldName: field.name,
        junctionVar: junctionVar,
        entityIdCol: entityIdCol,
        relSingular: relSingular,
        relIdCol: relIdCol
      })
    })
    .join('\n')
}
